import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { formatDecimal } from 'utils/formatter';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './RewardList.css';

class ItemRewardInfo extends Component {
  render() {
    const {
      isLastRow,
      isFirstRow,
      removeRewardItem,
      rewardType,
      discountType,
      rewardItems,
    } = this.props;
    if (rewardType !== 'ITEM') {
      return;
    }

    let pointAdditionalClass;
    let discountAdditionalClass;
    if (!removeRewardItem && !(isFirstRow && isLastRow)) {
      if (isFirstRow) {
        pointAdditionalClass = 'no-border-radius-left';
        // discountAdditionalClass = 'no-border-radius-bottom-right'
      } else if (isLastRow) {
        pointAdditionalClass = 'no-border-radius-top-left no-border-top';
        discountAdditionalClass = 'no-border-radius-top-right no-border-top';
      } else {
        pointAdditionalClass = 'no-border-radius-left no-border-top';
        discountAdditionalClass = 'no-border-radius-right no-border-top';
      }
    }

    const messages = [];
    if (discountType === 'PERCENTAGE') {
      for (let i = 0; i < rewardItems.length; i++) {
        let itemText = '';
        const rewardItem = rewardItems[i];
        const isFreeItem = this.props.discount === 100;

        if (rewardItem.type === 'CATEGORY') {
          if (isFreeItem) {
            itemText = `Any item in ${rewardItem.category_name} category for FREE`;
          } else {
            itemText = `${this.props.discount}% Discount on ${rewardItem.category_name} category`;
          }
        } else if (rewardItem.type === 'ITEM') {
          if (isFreeItem) {
            itemText = `${rewardItem.item_name} (All variants) for FREE`;
          } else {
            itemText = `${this.props.discount}% Discount on ${rewardItem.item_name} (All variants)`;
          }
        } else if (rewardItem.type === 'ITEM_VARIANT') {
          itemText = `${rewardItem.item_name} (`;
          for (let j = 0; j < rewardItem.item_variant_names.length; j++) {
            if (j > 0) {
              itemText += ', ';
            }
            itemText += `${rewardItem.item_variant_names[j]}`;
          }
          itemText += ')';

          if (isFreeItem) {
            itemText = `${itemText} for FREE`;
          } else {
            itemText = `${this.props.discount}% Discount on ${itemText}`;
          }
        }
        messages.push(itemText);
      }
    }

    return (
      <div>
        {messages.map((message, itemIndex) => (
          <div key={itemIndex}>
            <div className="col-md-4 no-padding-right ">
              <div
                style={{
                  borderRight: 'none',
                  color: '#8e8e8e',
                  fontWeight: '300',
                }}
                className={`form-control no-border-radius-right truncate ${pointAdditionalClass}`}
              >
                {formatDecimal(this.props.point)}
              </div>
            </div>
            <div className="col-md-8 no-padding-left">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Popover className={`${styles.popover}`} id="popover">
                    {message}
                  </Popover>
                }
              >
                <div
                  style={{ color: '#8e8e8e', fontWeight: '300' }}
                  className={`${
                    removeRewardItem ? 'has-feedback' : ''
                  } truncate`}
                >
                  <div
                    style={{ color: '#8e8e8e' }}
                    className={`form-control truncate no-border-radius-left ${discountAdditionalClass}`}
                  >
                    {message}
                  </div>
                  {removeRewardItem && (
                    <FontAwesome
                      onClick={() =>
                        this.props.removeRewardItem(this.props.index, itemIndex)
                      }
                      className={`form-control-feedback cursor-pointer ${
                        styles['remove-icon']
                      }`}
                      name="times-circle"
                    />
                  )}
                </div>
              </OverlayTrigger>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

ItemRewardInfo.propTypes = {
  point: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default ItemRewardInfo;
